import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6fe9e164")

_pushScopeId("data-v-6fe9e164")
const _hoisted_1 = { class: "pb-32" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Newbie’s First 14 days")
const _hoisted_3 = { class: "d-f mt-16 px-20" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Use WeTrade more than 8 days during the first 14 days after registration to get $2 coupon")
const _hoisted_5 = { class: "s-days-wrap df-between df-middle br-lg px-16" }
const _hoisted_6 = { class: "s-days br-lg df-middle" }
const _hoisted_7 = { class: "f-bold" }
const _hoisted_8 = { class: "c-success" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" /14 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("days")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Pic = _resolveComponent("Pic")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_t, {
      as: "p",
      path: "home_51",
      class: "t-center f-xxl f-bold"
    }, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_t, {
        as: "p",
        path: "home_52",
        class: "mr-16"
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_Pic, {
        src: "home/coupon$2",
        width: "80",
        height: "56"
      })
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        (_openBlock(), _createBlock(_Fragment, null, _renderList(14, (item, index) => {
          return _createVNode("div", {
            class: ["d-item flex-1", {'active': _ctx.days>=item}],
            key: index
          }, null, 2)
        }), 64))
      ]),
      _createVNode("p", _hoisted_7, [
        _createVNode("span", _hoisted_8, _toDisplayString(_ctx.days), 1),
        _hoisted_9,
        _createVNode(_component_t, { path: "home_53" }, {
          default: _withId(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ])
    ])
  ]))
})